<div class="sport-selector" ngbDropdown [placement]="dropDownPlacement">
  <button ngbDropdownToggle type="button" class="browse-sport-select">
    <span [ngClass]="'icon icon-' + selectedSport.name + '-new'"></span>
    <span class="sport-label">{{
      'shared.segments.' + selectedSport.label | translate
      }}</span>
  </button>
  <div ngbDropdownMenu aria-labelledby="browseSelectSport" class="browse-sport-options">
    @for(sport of sports;track $index){
    <button ngbDropdownItem (click)="onChangeSport(sport)" class="browse-sport-option"
      [ngClass]="{ selected: selectedSport === sport }">
      <span [ngClass]="'icon icon-' + sport.name + '-new'"></span>
      <span>{{ 'shared.segments.' + sport.label | translate }}</span>
    </button>
    }
  </div>
</div>